"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const MomentRange_1 = __importDefault(require("./MomentRange"));
class TimeSlot extends MomentRange_1.default {
    /**
     * Returns true iff timeslot overlaps with secondTimeslot.
     * @param secondTimeslot
     */
    overlaps(secondTimeslot) {
        return (secondTimeslot.getStart().isSameOrBefore(this.getStart()) && secondTimeslot.getEnd().isAfter(this.getStart()))
            || (secondTimeslot.getStart().isBefore(this.getEnd()) && secondTimeslot.getEnd().isSameOrAfter(this.getEnd()))
            || (secondTimeslot.getStart().isSameOrAfter(this.getStart()) && secondTimeslot.getEnd().isSameOrBefore(this.getEnd()));
    }
    /**
     * Generates time slot that starts
     * @param moment
     * @param durationInMinutes
     */
    static generateAllTimeSlotsInRange(m, durationInMinutes) {
        const timeSlots = [];
        let previousEnd = m.getStart();
        while (true) {
            const slotStart = previousEnd.clone();
            const slotEnd = previousEnd.clone().add(durationInMinutes, 'minutes');
            if (slotEnd.isAfter(m.getEnd())) {
                break;
            }
            else {
                const newSlot = new TimeSlot(slotStart, slotEnd);
                timeSlots.push(newSlot);
                previousEnd = newSlot.getEnd();
            }
        }
        return timeSlots;
    }
}
exports.default = TimeSlot;
/**
 * Returns the subset of timeslots that don't overlap with timeslots in b.
 * Implementation can still be optimized (by using sorted array for example).
 *
 * @param a
 * @param b
 */
function subtractOverlappingTimeslots(a, b) {
    const nonOverlappingTimeslots = [];
    const overlappingTimeslots = [];
    a.forEach((aItem) => {
        let overlapDetected = false;
        for (const bItem of b) {
            if (aItem.overlaps(bItem)) {
                overlapDetected = true;
                break;
            }
        }
        if (!overlapDetected) {
            nonOverlappingTimeslots.push(aItem);
        }
        else {
            overlappingTimeslots.push(aItem);
        }
    });
    return { overlapping: overlappingTimeslots, nonOverlapping: nonOverlappingTimeslots };
}
exports.subtractOverlappingTimeslots = subtractOverlappingTimeslots;
function sortTimeslotsOnStart(slots) {
    return slots.sort((a, b) => a.getStart().diff(b.getStart()));
}
exports.sortTimeslotsOnStart = sortTimeslotsOnStart;
//# sourceMappingURL=TimeSlot.js.map